import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { formatPrice } from '../../../../utils/utils';
import { toast } from 'react-toastify';

import './style.css'

import ProtectedAccess  from '../../../../components/ProtectedAccess'
import { useNavigate } from "react-router-dom";

import {
  Row
} from 'react-bootstrap';

import {
  FaHeart,
  FaShoppingCart
} from "react-icons/fa";

import { handle_favorites } from '../../../../api/books';

import { useAppStore } from "../../../../context/state";
import { getUser } from '../../../../utils/common';


const BookItem = (props) => {

  const { book, lang, handleShow }=props;

  const addBook = useAppStore((state) => state.addBook)
  const shopingCart = useAppStore((state) => state.shopingCart)
  
  const user = getUser();
  const history = useNavigate();
  const [isFav, setIsFav] = useState(false);
  
  const navigate = useNavigate();

  const handleFavorite = async () => {

    if (!user) {
      let customId = 123;
      toast.warning(lang.user.error.not_logged_in, {
        toastId: customId,
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: false,
        onClose: () => {
          history('/editorial/user-access')
        }
      });
      return;
    }
    const user_id= user.id || user._id;

    const body = {
      user_id:user_id, 
      book_id: book._id,
      addToFav: !isFav
    };

    try {
      await handle_favorites(body);
      const success_message = isFav ? lang.book.success.delete_favorite : lang.book.success.add_favorite;
      
      toast.success(success_message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: false
      });

      if(!isFav){
        book.favorites.push(user_id)
      }else{
        const index = book.favorites.indexOf(user_id);
        book.favorites.splice(index, 1);
      }

      setIsFav(!isFav);
    } catch (error) {
      toast.error(lang.ERR_NETWORK);
    }
  }


  const onAddShoppingCart  = (book) => {
    const existBook = shopingCart.find(el => el._id === book._id);
    if (existBook) {
      toast.info(lang.book.error.already_in_cart, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: false
      });
      return;
    }
    let bookToAdd = {...book};
    bookToAdd.qty = 1;
    addBook(bookToAdd);
    toast.success(lang.book.success.add_to_cart, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: true,
      pauseOnFocusLoss: false,
      closeOnClick: true,
      pauseOnHover: false
    });
  }

  const truncate =(str, length=90)=>{
    return str.length > length ? `${str.substring(0, length)} ...` : str;
  }

  const goToPage=(book)=>{
    navigate(`/editorial/books/${book._id}`);
  }

  return (
    <div style={{
      maxWidth:'202px',
      padding: '0px 0px'
    }}>
      <div className="card gallery-item">
        <div className='book-image' onClick={()=>goToPage(book)} >
          <img 
            alt="book_cover" src={book.coverImage || '/assets/app/cover.jpg' } className="card-thumbnail-top"
          />
        </div>
        <div className='book-tittle'>
        <Link
            to={`/editorial/books/${book._id}`}
            style={{textDecoration:'none'}}
            >
            {truncate(book.title, 45)}
          </Link>
        </div>
        <div className="card-body" style={{
          padding:'10px'
        }}>
          <p className="card-text" style={{ minHeight:'100px', maxHeight:'300px' }}>
            <span dangerouslySetInnerHTML={{__html: truncate(book.summary, 80)}} /><br/>
            (<Link 
              className="text-primary" 
              style={{cursor:'pointer', textDecoration:'underline'}} 
              to={`/editorial/books/${book._id}`}>ver más</Link>
            )<br/>
          </p>
          <p className="card-text">
            <Link to={
              book?.authors[0]?._id ? `/editorial/authors/${book?.authors[0]?._id}`:
                `/editorial/authors/${book?.authors[0]}`
              }> 
              <small className="text-muted">{truncate(book?.collaborators[0]?? 'Sin autores', 30)}</small>
            </Link>
            <br/>
            {/* <small onClick={()=>console.log("cite")} className="text-muted"> {lang?.book.how_quote} </small> */}
          </p>

          {/* <Row>
            <Col sm={12} md={4} style={{cursor:'pointer'}} className='text-likes text-center' onClick={handleFavorite}>
              <FaHeart /> {book?.favorites?.length < 9? book?.favorites?.length:"10+"}
            </Col>
            <Col className='text-primary text-center' style={{cursor:'pointer'}} onClick={() => onAddShoppingCart(book)}>
              <FaShoppingCart/> Agregar
            </Col>
          </Row>
          <Row>
            <Col>{formatPrice(`${book.price}`, lang?.cart_coin)}</Col>
          </Row> */}
          <ProtectedAccess 
              element={
                  <div className="btn-group w-100">
                      <button className="btn btn-sm btn-block btn-primary badge" type="button" onClick={handleShow} > Modificar</button>
                  </div>
              }
              role={['admin', 'editor']}
          />
        </div>
      </div>
    </div>
  );
};
export default BookItem;
